import { api } from '@/lib/axios';
import type { LoginRequest, LoginResponse, User } from '@monitor/shared';

export async function login(payload: LoginRequest): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/api/auth/login', payload);
  return data;
}

export async function fetchCurrentUser(): Promise<User> {
  const { data } = await api.get<User>('/api/users/me');
  return data;
}

/** super_admin: start impersonating a user. Returns a session for the target
 *  (carrying `impersonator` so we can return). */
export async function impersonateUser(userId: number): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>(`/api/auth/impersonate/${userId}`);
  return data;
}

/** Return from an impersonated session back to the original super_admin. */
export async function stopImpersonation(): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/api/auth/stop-impersonation');
  return data;
}

export async function finishReset(
  newPassword: string,
): Promise<{ accessToken: string; refreshToken: string; mustChangePassword: boolean }> {
  const { data } = await api.post<{
    accessToken: string;
    refreshToken: string;
    mustChangePassword: boolean;
  }>('/api/auth/finish-reset', { newPassword });
  return data;
}
